import React from 'react';
import {Trans} from 'react-i18next';
import {CONSTANTS} from '../../../../../../Shared/Constants/Constants';
import {IssueProfile} from '../../../SensorIssueForm/IssueAlarmFormState';

type IssueAlarmLostMeasurementProps = {
	sensorIssuesForm: IssueProfile;
	show: boolean;
};

export default function IssueAlarmsLostMeasurementComponent(props: IssueAlarmLostMeasurementProps) {
	return (
		props.show && (
			<tr>
				<td>
					<Trans i18nKey={'sensorWizard.summary.lostMeasurementAlarm'} />
				</td>
				<td>
					{(() => {
						if (props.sensorIssuesForm == null) {
							return CONSTANTS.NOT_AVAILABLE;
						}
						return props.sensorIssuesForm.lost_measurement_alarm ? CONSTANTS.YES : CONSTANTS.NO;
					})()}
				</td>
			</tr>
		)
	);
}
